import React from 'react'
import Head from 'next/head'
import DocumentSearchRoute from '../../../../routes/DocumentSearch'
import { useIntl } from 'react-intl'
import { Chat, ChatChannel } from '@src/components/Chat'

const Search = () => {
  const intl = useIntl()
  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({ id: 'DOCUMENTS', defaultMessage: 'Documents' })}
        </title>
      </Head>
      <DocumentSearchRoute />
      <Chat
        text="Chat with Customer Care"
        channel={ChatChannel.CustomerService}
      />
    </>
  )
}

export default Search
